(function () {
  var ANN_GAP = 12; /* px entre la barra de anuncios y el header flotante */
  var ASSET_V = '20261012b'; /* subir al cambiar basiq-mobile.css / .js para saltar la caché */

  /* ---------- Ajustes móvil globales: se cargan desde aquí para estar en todas las páginas ---------- */
  (function loadMobileAssets() {
    var s = document.currentScript;
    if (!s || !s.src) return;
    var base = s.src.split('?')[0].replace(/basiq-header\.js$/, '');
    if (!document.querySelector('link[data-basiq-mobile]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = base + 'basiq-mobile.css?v=' + ASSET_V;
      l.setAttribute('data-basiq-mobile', '');
      document.head.appendChild(l);
    }
    if (!document.querySelector('script[data-basiq-mobile]')) {
      var j = document.createElement('script');
      j.src = base + 'basiq-mobile.js?v=' + ASSET_V;
      j.defer = true;
      j.setAttribute('data-basiq-mobile', '');
      document.head.appendChild(j);
    }
  })();

  /* ---------- Bloqueo de scroll que también funciona en iPhone ---------- */
  if (!window.BasiqScrollLock) {
    (function () {
      var count = 0;
      var savedY = 0;
      window.BasiqScrollLock = {
        lock: function () {
          if (count++ > 0) return;
          savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
          var b = document.body;
          b.style.position = 'fixed';
          b.style.top = (-savedY) + 'px';
          b.style.left = '0';
          b.style.right = '0';
          b.style.width = '100%';
          document.documentElement.style.overflow = 'hidden';
        },
        unlock: function () {
          if (count === 0) return;
          if (--count > 0) return;
          var b = document.body;
          b.style.position = '';
          b.style.top = '';
          b.style.left = '';
          b.style.right = '';
          b.style.width = '';
          document.documentElement.style.overflow = '';
          try {
            window.scrollTo({ top: savedY, left: 0, behavior: 'instant' });
          } catch (e) {
            window.scrollTo(0, savedY);
          }
        }
      };
    })();
  }

  function resetMobilePanels(nav) {
    var panels = nav.querySelectorAll('.basiq-mobile-panel');
    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.panel === 'root');
    });
  }

  function getScrollPosition(target) {
    if (target === document || target === window) {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }
    return target.scrollTop || 0;
  }

  /* Barra de anuncios del tema (sección del grupo de header) */
  function findAnnouncement() {
    var sections = document.querySelectorAll('#header-group > .shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (s.querySelector('.basiq-header-wrapper')) continue;
      if (/announcement/i.test(s.id) || s.querySelector('[class*="announcement"], announcement-bar-component')) {
        return s;
      }
    }
    return null;
  }

  function initBasiqHeader() {
    var wrapper = document.querySelector('.basiq-header-wrapper');
    if (!wrapper) return;
    if (wrapper.dataset.basiqInit === 'true') return;
    wrapper.dataset.basiqInit = 'true';

    var hideOnScroll = wrapper.dataset.hideOnScroll === 'true';
    var isFixed = !wrapper.classList.contains('is-static');
    var lastScrollY = 0;
    var scrollThreshold = 60;
    var ticking = false;
    var pendingTarget = null;
    var mainRow = wrapper.querySelector('.basiq-header__main');

    /* ---- Barra de anuncios pegada al header ---- */
    var ann = isFixed ? findAnnouncement() : null;
    var spacer = null;

    if (ann) {
      spacer = ann.previousElementSibling && ann.previousElementSibling.classList.contains('basiq-ann-spacer')
        ? ann.previousElementSibling
        : null;
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'basiq-ann-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        ann.parentNode.insertBefore(spacer, ann);
      }
      ann.classList.add('basiq-ann-fixed');
    }

    function layout() {
      var top = 0;
      if (ann) {
        var h = ann.offsetHeight;
        spacer.style.height = h + 'px';
        top = h + ANN_GAP;
        wrapper.style.setProperty('--basiq-top-spacing', top + 'px');
      } else {
        top = parseFloat(getComputedStyle(wrapper).top) || 0;
      }

      /* Hueco que ocupa todo lo fijo de arriba (sin contar el menú móvil abierto),
         para que las secciones empiecen justo debajo */
      var headerH = mainRow ? mainRow.offsetHeight + 2 : wrapper.offsetHeight;
      var offset = isFixed ? Math.round(top + headerH) : 0;
      document.documentElement.style.setProperty('--basiq-header-offset', offset + 'px');
      /* Parte del header que queda por encima del contenido (sin el hueco de la barra de anuncios) */
      var overlap = isFixed ? Math.max(0, offset - (ann ? ann.offsetHeight : 0)) : 0;
      document.documentElement.style.setProperty('--basiq-header-overlap', overlap + 'px');
    }

    layout();
    window.addEventListener('resize', layout);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(layout);
      if (ann) ro.observe(ann);
      if (mainRow) ro.observe(mainRow);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout).catch(function () {});
    window.addEventListener('load', layout);

    function setHidden(hidden) {
      wrapper.classList.toggle('is-hidden', hidden);
      if (ann) ann.classList.toggle('is-hidden', hidden);
    }

    function updateHeaderState() {
      if (wrapper.dataset.dropdownOpen === 'true') { ticking = false; return; }

      /* Con el scroll bloqueado (carrito o selector abiertos) no se toca el header */
      if (document.body.style.position === 'fixed') { ticking = false; return; }

      var currentScrollY = getScrollPosition(pendingTarget || document);

      if (hideOnScroll) {
        var scrollingDown = currentScrollY > lastScrollY;
        var pastThreshold = currentScrollY > scrollThreshold;

        if (scrollingDown && pastThreshold) {
          setHidden(true);
        } else if (!scrollingDown) {
          setHidden(false);
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    function onScroll(event) {
      pendingTarget = event.target || document;
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderState);
        ticking = true;
      }
    }

    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    lastScrollY = getScrollPosition(document);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.basiq-header__menu-toggle');
    if (toggle) {
      var header = toggle.closest('.basiq-header');
      var mobileNav = header ? header.querySelector('.basiq-header__mobile-nav') : null;
      if (!mobileNav) return;

      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      mobileNav.setAttribute('aria-hidden', !isOpen);

      if (!isOpen) {
        resetMobilePanels(mobileNav);
      }
      return;
    }

    var panelTrigger = event.target.closest('[data-open-panel]');
    if (panelTrigger) {
      var nav = panelTrigger.closest('.basiq-header__mobile-nav');
      if (!nav) return;

      var targetId = panelTrigger.dataset.openPanel;
      var panels = nav.querySelectorAll('.basiq-mobile-panel');
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.panel === targetId);
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBasiqHeader);
  } else {
    initBasiqHeader();
  }

  document.addEventListener('shopify:section:load', function () {
    var wrapper = document.querySelector('.basiq-header-wrapper');
    if (wrapper) delete wrapper.dataset.basiqInit;
    initBasiqHeader();
  });
})();
